import React, { useState } from 'react';
import { ClockIcon, MailIcon, MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
// Special header for the Contact page that links back to main site
function ContactPageHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-[#8A9A5B] shadow-sm sticky top-0 z-50" data-id="element-51" data-mp="2iv5tpxake6np">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52" data-mp="247t1jpq952oc">
        <div className="flex justify-between items-center py-4" data-id="element-53" data-mp="245gewz9ju44y">
          <div className="flex items-center" data-id="element-54" data-mp="28z2t4vvd2g2v">
            <a href="https://meyerbkt.com" data-id="element-55" data-mp="29041utowmqhf">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mhSQzqAkdBcNMQ8aCTM7Tt/Gray_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-12 w-auto" data-id="element-56" data-mp="1v7xn9c1egrk3" />
            </a>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-57" data-mp="1q6qh1hewo0fj">
            <a href="https://meyerbkt.com/#services" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-58" data-mp="sbuin6xh3yvw">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-59" data-mp="nf46uvspbpga">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-60" data-mp="x934bhhtyl1w">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-61" data-mp="idn40uqnpsx2">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="text-white hover:text-gray-200 text-sm font-medium" data-id="element-62" data-mp="dl3rm13ph3tu">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="bg-[#3A4A46] text-white px-4 py-2 rounded hover:bg-opacity-80 transition-colors" data-id="element-63" data-mp="3hz28rgzo2bzr">
              Book a Call
            </a>
          </nav>
          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-64" data-mp="1uqu0nmpzqorb">
            <button onClick={toggleMenu} className="text-white hover:text-gray-200 focus:outline-none" data-id="element-65" data-mp="1zpf19n95naga">
              {isMenuOpen ? <XIcon className="h-6 w-6" data-id="element-66" data-mp="123r4h18seq48" /> : <MenuIcon className="h-6 w-6" data-id="element-67" data-mp="171slzhqkehdl" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-[#9BAB6C] border-t border-[#79894A]" data-id="element-68" data-mp="1gzgiac3tjwxv">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-69" data-mp="1gwkmoufg1kcl">
            <a href="https://meyerbkt.com/#services" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-70" data-mp="2nehgkogbgr7m">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-71" data-mp="br48pramvtb6">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-72" data-mp="20049lil3qul">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-73" data-mp="3k7za12bs95n5">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="block px-3 py-2 text-base font-medium text-white hover:bg-[#79894A]" onClick={() => setIsMenuOpen(false)} data-id="element-74" data-mp="1dghrcv0akh4k">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="block px-3 py-2 text-base font-medium bg-[#3A4A46] text-white rounded" onClick={() => setIsMenuOpen(false)} data-id="element-75" data-mp="f32p0m8hwugt">
              Book a Call
            </a>
          </div>
        </div>}
    </header>;
}
// Special footer for the Contact page that links back to main site
function ContactPageFooter() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-white py-8" data-id="element-76" data-mp="3ellkwp44d4ga">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-77" data-mp="3jj5668z8ihhq">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-78" data-mp="3jjn3za1jp3rr">
          <div className="mb-4 md:mb-0" data-id="element-79" data-mp="34mnxxqmcdize">
            <a href="https://meyerbkt.com" data-id="element-80" data-mp="39l7ipnp78oq6">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ftirAgMM8xqTRnsAszCk3U/New_Logo.png" alt="Meyer Bookkeeping & Tax Logo" className="h-10 w-auto" data-id="element-81" data-mp="39jw56w5yc2lv" />
            </a>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-8 text-center md:text-left" data-id="element-82" data-mp="2zxbr8yrgtack">
            <a href="https://meyerbkt.com/#services" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-83" data-mp="2uyidr6c6hjce">
              Services
            </a>
            <a href="https://meyerbkt.com/#process" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-84" data-mp="38vx7uoddmfap">
              Process
            </a>
            <a href="https://meyerbkt.com/#testimonials" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-85" data-mp="3iq7bx3bol219">
              Testimonials
            </a>
            <a href="https://meyerbkt.com/#about" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-86" data-mp="3sk69rq4q1zne">
              About
            </a>
            <a href="https://meyerbkt.com/#faq" className="text-gray-300 hover:text-white mb-2 md:mb-0" data-id="element-87" data-mp="3us77fje7t799">
              FAQ
            </a>
            <a href="https://meyerbkt.com/contact" className="text-gray-300 hover:text-white" data-id="element-88" data-mp="8ie1dveqgqh2">
              Contact
            </a>
          </div>
        </div>
        <div className="pt-6 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-89" data-mp="i87cywevl5lb">
          <p className="text-gray-400 text-sm" data-id="element-90" data-mp="m8zoxxf4tola">
            &copy; {currentYear} Meyer Bookkeeping & Tax. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0 flex items-center" data-id="element-91" data-mp="w8i4m1o0eo7j">
            <div className="flex space-x-4 items-center" data-id="element-92" data-mp="w7ywtds2pg78">
              <a href="https://www.facebook.com/profile.php?id=61578990285219" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-93" data-mp="2t1tq24on2url">
                <span className="sr-only" data-id="element-94" data-mp="2qhx4ayetw766">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-95" data-mp="2lplzbh58dv6r">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-96" data-mp="2bs7ukeso6uua" />
                </svg>
              </a>
              <a href="https://www.instagram.com/meyerbookkeeping/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-97" data-mp="2uhxt9czk00rh">
                <span className="sr-only" data-id="element-98" data-mp="28rfujgxzesj0">Instagram</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-99" data-mp="28puzzrbo39l5">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" data-id="element-100" data-mp="1zs2iqhmdxrv4" />
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/meyer-bookkeeping-tax/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white" data-id="element-101" data-mp="1xruy35s6fwb4">
                <span className="sr-only" data-id="element-102" data-mp="1j408vzddoa2s">LinkedIn</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-id="element-103" data-mp="1j3gwszaesfwo">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" data-id="element-104" data-mp="1a2ipo84obs9v" />
                </svg>
              </a>
              <a href="https://www.bible.com/bible/111/1PE.4.NIV" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white ml-4" data-id="element-105" data-mp="32252rv77p4gb">
                1 Peter 4:10
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
export function ContactPage() {
  return <div className="font-sans" data-id="element-106" data-mp="2j5dfzbsgo77i">
      <ContactPageHeader data-id="element-107" data-mp="2o2x37174zubl" />
      <div className="bg-white py-16" data-id="element-108" data-mp="2o23rrmx8ggn4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109" data-mp="2o35ggu7691nb">
          <h1 className="text-3xl md:text-4xl font-bold text-[#3A4A46] mb-4 text-center" data-id="element-110" data-mp="2t1qecmyyb98l">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-600 mb-8 text-center" data-id="element-111" data-mp="2y2nuku0eht7g">
            I would love to hear from you! Fill out the form below and I will be
            back in touch.
          </p>
          <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-112" data-mp="d9j11f9xr0dv">
            {/* Contact Information */}
            <div className="md:w-1/2 bg-[#F5F7F6] rounded-lg p-8 shadow-sm" data-id="element-113" data-mp="29c5otd82005y">
              <div className="space-y-6" data-id="element-114" data-mp="24e45cr6ptyty">
                <div data-id="element-115" data-mp="24h9to47iswom">
                  <h3 className="text-xl font-bold text-[#3A4A46] flex items-center gap-2 mb-3" data-id="element-116" data-mp="2ief1a8mvu3lz">
                    <ClockIcon className="h-5 w-5 text-[#8A9A5B]" data-id="element-117" data-mp="2edczbk1kzdgb" />
                    Business Hours
                  </h3>
                  <div className="ml-7 space-y-2 text-gray-700" data-id="element-118" data-mp="1qok79yo2xpqz">
                    <p data-id="element-119" data-mp="1loo3o0jao0by">Monday - Thursday: 8:00 AM - 3:30 PM</p>
                    <p data-id="element-120" data-mp="1lq8x1mtvhd88">Friday: 8:00 AM - 12:00 PM</p>
                    <p className="italic" data-id="element-121" data-mp="1zgcbhrmig2n4">
                      Additional times available by appointment
                    </p>
                  </div>
                </div>
                <div data-id="element-122" data-mp="16zi58esa6e54">
                  <h3 className="text-xl font-bold text-[#3A4A46] flex items-center gap-2 mb-3" data-id="element-123" data-mp="16z04p5yl5dre">
                    <MailIcon className="h-5 w-5 text-[#8A9A5B]" data-id="element-124" data-mp="12yg2hnz5njye" />
                    Email
                  </h3>
                  <div className="ml-7" data-id="element-125" data-mp="ssydivo7zqfi">
                    <a href="mailto:info@meyerbkt.com" className="text-[#8A9A5B] hover:underline" data-id="element-126" data-mp="srwrxx9kvljj">
                      info@meyerbkt.com
                    </a>
                  </div>
                </div>
                <div data-id="element-127" data-mp="nvepj41pzzad">
                  <h3 className="text-xl font-bold text-[#3A4A46] flex items-center gap-2 mb-3" data-id="element-128" data-mp="nsskbb2axvvb">
                    <PhoneIcon className="h-5 w-5 text-[#8A9A5B]" data-id="element-129" data-mp="1biegdpndnuz3" />
                    Call or Text
                  </h3>
                  <div className="ml-7" data-id="element-130" data-mp="11mbfso86c4e9">
                    <a href="tel:7122304533" className="text-[#8A9A5B] hover:underline" data-id="element-131" data-mp="11li5jda0awrd">
                      712-230-4533
                    </a>
                  </div>
                </div>
                <div className="pt-4" data-id="element-132" data-mp="3rblq31ou9gex">
                  <a href="https://outlook.office.com/book/MeyerBookkeepingTax@meyerbkt.com/" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#3A4A46] text-white px-5 py-3 rounded-md hover:bg-[#8A9A5B] transition-colors w-full text-center font-medium" data-id="element-133" data-mp="3rcolnmx3w716">
                    Book Discovery Call
                  </a>
                </div>
              </div>
            </div>
            {/* Contact Form */}
            <div className="md:w-1/2" data-id="element-134" data-mp="ubgh609ash0o">
              <div className="bg-white rounded-lg p-2" data-id="element-135" data-mp="pdeqou9jlff6">
                <iframe src="https://preview.mailerlite.io/forms/1833129/167701687116498504/share" style={{
                width: '100%',
                height: '600px',
                border: 'none'
              }} title="Contact Form" data-id="element-136" data-mp="pdws05b2ajty"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactPageFooter data-id="element-137" data-mp="307aqnh920vmx" />
    </div>;
}